export var DEFAULT_LOCALE = "en-US";
export var IS_LOCALISATION_FEATURE_ENABLED = "IS_LOCALISATION_FEATURE_ENABLED";

//# sourceMappingURL=localisation.js.map